import rollbar from '../rollbar';


// Use this action to show a toast message.
export function toast(text) {
  return function(dispatch) {
    dispatch({ type: 'UI_TOAST', payload: text });
  };
}

// Show the user a generic error message.
export function showError(error) {
  rollbar.error(error);
  return toast('Oops. Something went wrong. Please try again.');
}


// Payload is title, body, and url; use null to hide notification.
export function setNotification(payload) {
  return { type: 'SET_NOTIFICATION', payload };
}


// Payload is true/false
export function setIsLoadingConversations(payload) {
  return { type: 'SET_IS_LOADING_CONVERSATIONS', payload };
}

// Payload is true/false
export function setIsLoadingContacts(payload) {
  return { type: 'SET_IS_LOADING_CONTACTS', payload };
}


// -- Progress / preloader --

export function progressStart() {
  return function(dispatch) {
    dispatch({ type: 'PROGRESS_START' });
  };
}


export function progressEnd() {
  return function(dispatch) {
    // Some actions sequence multiple requests in a row, eg updating user and
    // then reading team members list.  We want this progressEnd to overlap with
    // the next progressStart, so the indicator remains on screen continuously.
    setTimeout(function overlap() {
      dispatch({ type: 'PROGRESS_END' });
    });
  };
}
